import EntityPresenter, { bindPresenterMethods } from './entityPresenter'

export default class ProfilePresenter extends EntityPresenter {
  static urn = 'profiles'
  static key = 'profile'

  static navOptions(key = 'profiles') {
    const routes = {
      profiles: {
        icon: 'person',
        pageRoutes: ['profile'],
      }
    }
    return routes[key]
  }
}

bindPresenterMethods(ProfilePresenter)
